import { IconLoader } from '@ui/src';
import AdditionalInfoBlock from '../../../individual/aml/additional-info-block';
import { ExpectedOriginFundsTypes } from './types';
import ExpectedOriginFundsContent from './expected-origin-funds-content';

import cn from './styles.module.css';

const ExpectedOriginFunds = ({
  expectedFundsOriginsIsLoading,
  expectedFundsOriginsIsFetching,
  accountsFlowsValues,
  errors,
  status,
  accountsCurrenciesValues,
  currencies,
  deleteExpectedFundsOriginsInProgress,
  onDeleteExpectedFundsOrigins,
  selectedExpectedFundsOriginsId,
  expectedFundsOriginsValues,
  setExpectedFundsOriginsValues,
  countries,
}: ExpectedOriginFundsTypes) => {
  const incomingExpectedFundsOfOrigins = expectedFundsOriginsValues?.filter(
    (item) => item.transactionType === 'INCOMING',
  );
  const outgoingExpectedFundsOfOrigins = expectedFundsOriginsValues?.filter(
    (item) => item.transactionType === 'OUTGOING',
  );

  return (
    <AdditionalInfoBlock title="Expected origin of funds">
      <div className={cn.accountsCurrenciesList}>
        {(expectedFundsOriginsIsLoading || expectedFundsOriginsIsFetching) && (
          <div className={cn.accountsCurrenciesLoader}>
            <IconLoader />
          </div>
        )}
        {errors?.questionnairesExpectedFundsOrigins?.message && (
          <div className={cn.questionnarieError}>
            {errors?.questionnairesExpectedFundsOrigins?.message}
          </div>
        )}
        {!accountsFlowsValues?.length && (
          <div className={cn.emptyAccountsFlows}>
            Add currencies in&nbsp;
            <strong>
              &quot;Purpose for establishing business relationship&quot;
            </strong>
          </div>
        )}
        {accountsFlowsValues &&
          accountsFlowsValues?.length > 0 &&
          !expectedFundsOriginsIsLoading &&
          !expectedFundsOriginsIsFetching && (
            <>
              <ExpectedOriginFundsContent
                status={status}
                currencies={
                  accountsCurrenciesValues?.map((item) => ({
                    name: currencies?.find(
                      (currency) => currency.value === item.currencyId,
                    )?.name as string,
                    suffix: currencies?.find(
                      (currency) => currency.value === item.currencyId,
                    )?.suffix as string,
                    value: item.currencyId,
                  })) || []
                }
                deleteExpectedFundsOriginsInProgress={
                  deleteExpectedFundsOriginsInProgress
                }
                onDeleteExpectedFundsOrigins={onDeleteExpectedFundsOrigins}
                selectedExpectedFundsOriginsId={selectedExpectedFundsOriginsId}
                expectedFundsOriginsValues={incomingExpectedFundsOfOrigins}
                expectedFundsOriginsValuesList={expectedFundsOriginsValues}
                setExpectedFundsOriginsValues={setExpectedFundsOriginsValues}
                countries={countries}
                type="INCOMING"
              />
              <ExpectedOriginFundsContent
                status={status}
                currencies={
                  accountsCurrenciesValues?.map((item) => ({
                    name: currencies?.find(
                      (currency) => currency.value === item.currencyId,
                    )?.name as string,
                    suffix: currencies?.find(
                      (currency) => currency.value === item.currencyId,
                    )?.suffix as string,
                    value: item.currencyId,
                  })) || []
                }
                deleteExpectedFundsOriginsInProgress={
                  deleteExpectedFundsOriginsInProgress
                }
                onDeleteExpectedFundsOrigins={onDeleteExpectedFundsOrigins}
                selectedExpectedFundsOriginsId={selectedExpectedFundsOriginsId}
                expectedFundsOriginsValues={outgoingExpectedFundsOfOrigins}
                expectedFundsOriginsValuesList={expectedFundsOriginsValues}
                setExpectedFundsOriginsValues={setExpectedFundsOriginsValues}
                countries={countries}
                type="OUTGOING"
              />
            </>
          )}
      </div>
    </AdditionalInfoBlock>
  );
};

export default ExpectedOriginFunds;
